import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from "@/views/LoginPage.vue";
import AdminLoginPage from "@/views/admin/AdminLoginPage.vue";
import RegisterPage from "@/views/RegisterPage.vue";
import UserLayout from "@/views/user/UserLayout.vue";
import AdminLayout from "@/views/admin/AdminLayout.vue";
import UserHomePage from "@/views/user/UserHomePage.vue";
import AdminHomePage from "@/views/admin/AdminHomePage.vue";
import ComputerVisionPage from "@/views/ComputerVisionPage.vue";
import VideoStreamPage from "@/views/VideoStreamPage.vue";
import UserManagementPage from "@/views/admin/UserManagementPage.vue";
import LogManagementPage from "@/views/admin/LogManagementPage.vue";
import PersonalCenterPage from "@/views/PersonalCenterPage.vue";
import UserAnnouncementPage from "@/views/user/UserAnnouncementPage.vue";
import AdminAnnouncementPage from "@/views/admin/AdminAnnouncementPage.vue";
import ModelManagementPage from "@/views/admin/ModelManagementPage.vue";

Vue.use(VueRouter)

const routes = [
  // ===== 用户前台 =====
  {
    path: "/user",
    component: UserLayout,
    redirect: "/user/home",
    children: [
      {
        path: "home",
        name: "用户首页",
        component: UserHomePage
      },

      {
        path: "vision",
        name: "计算机视觉设置",
        component: ComputerVisionPage
      },
      {
        path: "video",
        name: "USB视频传输设置",
        component: VideoStreamPage
      },
      {
        path: "announcement",
        name: "系统公告",
        component: UserAnnouncementPage
      }
    ]
  },

  // ===== 管理员后台 =====
  {
    path: "/admin",
    component: AdminLayout,
    redirect: "/admin/home",
    children: [
      {
        path: "home",
        name: "管理首页",
        component: AdminHomePage
      },
      {
        path: "users",
        name: "成员信息管理",
        component: UserManagementPage
      },
      {
        path: "logs",
        name: "系统日志管理",
        component: LogManagementPage
      },

      {
        path: "models",
        name: "YOLO模型管理",
        component: ModelManagementPage
      },
      {
        path: "vision",
        name: "计算机视觉分析(管理)",
        component: ComputerVisionPage
      },
      {
        path: "video",
        name: "实验视频传输(管理)",
        component: VideoStreamPage
      },
      {
        path: "announcement",
        name: "公告管理",
        component: AdminAnnouncementPage
      }
    ]
  },

  // ===== 个人中心（用户和管理员共用） =====
  {
    path: "/personal-center",
    name: "个人中心",
    component: PersonalCenterPage
  },

  // ===== 兼容旧路由重定向 =====
  {
    path: "/main",
    redirect: "/user/home"
  },
  {
    path: "/usermainpage",
    redirect: "/user/home"
  },
  {
    path: "/main/home",
    redirect: "/user/home"
  },

  {
    path: "/main/vision",
    redirect: "/user/vision"
  },
  {
    path: "/main/video",
    redirect: "/user/video"
  },

  // ===== 登录与注册 =====
  {
    path:"/",
    redirect:"/login"
  },
  {
    path: "/login",
    component: LoginPage
  },
  {
    path: "/login2",
    component: AdminLoginPage
  },
  {
    path: "/zhuce",
    component: RegisterPage
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
